// extracted by mini-css-extract-plugin
module.exports = {"infoText":"homePagecontent_infoText__2mlPw","logOut":"homePagecontent_logOut__37uvL"};